import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash/fp';
import { useToggleState } from 'app/lib/hooks';
import { Collapsible } from 'app/components/core/Collapsible';
import { LinkButton } from 'app/components/core/LinkButton';
import { Icon, IconSize } from 'app/components/core/Icon';
import { StatusDialog, DialogType } from 'app/components/composite/StatusDialog';
import * as styles from './HealthcheckOverlay.css';

export const HealthcheckOverlay = ({ degradedSystems }) => {
    const { t } = useTranslation();
    const [isDetailsDialogOpen, toggleDetailsDialog] = useToggleState(false);

    if (isEmpty(degradedSystems)) {
        return null;
    }

    if (degradedSystems.length > 1) {
        return (
            <div className={styles.base}>
                <Icon variant="status-error" size={IconSize.SMALL} inline />
                <span>{t('healthcheck:multipleSystems')}</span>
            </div>
        );
    }

    const { name, message: details, stackTraceAsString } = degradedSystems[0];

    const message = t(`healthcheck:${name}`);

    return (
        <Fragment>
            <div className={styles.base}>
                <Icon variant="status-warning" size={IconSize.SMALL} inline />
                <span>{message}</span>
                <LinkButton onClick={toggleDetailsDialog}>Show Details</LinkButton>
            </div>
            {isDetailsDialogOpen && (
                <StatusDialog
                    title="System degration"
                    width={600}
                    onSubmit={toggleDetailsDialog}
                    submitButtonLabel="Acknowledge"
                    type={DialogType.WARNING}>
                    <Fragment>
                        <div className={styles.details}>{details}</div>
                        {stackTraceAsString && (
                            <Collapsible
                                trigger={t('components:HealthCheckOverlay.stackTraceToggle')}
                                collapsed>
                                <pre>{stackTraceAsString}</pre>
                            </Collapsible>
                        )}
                    </Fragment>
                </StatusDialog>
            )}
        </Fragment>
    );
};
